const defaultState: IApplicationState = {
	productFormBreadcrumb: [],
	otherLoadedEntities: [],
	availabilities: null,
	currencies: [],
	configOptions: [],
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/store/default-state.ts